import { cn } from "./cn";

/**
 * Card / surface (design system §6.1).
 *
 * `rounded-lg ring-1 ring-neutral-200 bg-white`. `interactive` agrega el
 * hover para cards clickeables.
 */
export type CardPadding = "none" | "sm" | "md" | "lg";

const PADDING_CLS: Record<CardPadding, string> = {
  none: "",
  sm: "p-3",
  md: "p-4",
  lg: "p-6",
};

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding | undefined;
  /** Agrega hover (ring + shadow) para cards clickeables. */
  interactive?: boolean | undefined;
}

export function Card({
  padding = "md",
  interactive = false,
  className,
  children,
  ...rest
}: CardProps): JSX.Element {
  return (
    <div
      className={cn(
        "rounded-lg bg-white ring-1 ring-neutral-200",
        PADDING_CLS[padding],
        interactive && "transition-all hover:ring-neutral-300 hover:shadow-sm",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
